namespace $ {

	export function $shm_hitalama_cors_proxy_url() {
		const host = $mol_dom_context.location?.hostname ?? ''
		return host.includes( '158-160-195-195' )
			? 'https://cors.158-160-195-195.ip.hyoo.ru'
			: 'https://cors.crus.51-250-36-140.ip.hyoo.ru'
	}

	export function $shm_hitalama_cors_proxy( url: string ) {
		return `${ $shm_hitalama_cors_proxy_url() }/${ url }`
	}

}
